import React from 'react';
import PropTypes from 'prop-types';

import Grid from 'shared-components/components/Grid';
import GridItem from 'shared-components/components/GridItem';

import HpArrow from 'shared-vectors/icons/HpArrow';
import { Icon } from 'shared-vectors';

import { queryBuilder } from '@modals/factories';

import { useCtxGlobal } from '@client/app/Container';

import SearchBlock from '../SearchBlock';

const PTypes = ({
  availableResults,
  propertyTypes,
  licenseTypeGroups,
}) => {
  const {
    isMobile,
    isSmallMobile,
    openModal,
    pageType,
    filtersProps,
  } = useCtxGlobal();

  const choose = () => openModal && openModal(queryBuilder({
    isMobile,
    isSmallMobile,
    availableResults,
    pageType,
    filtersProps,
    panelChooseBy: {
      isMobile,
      actionClicked: 'propertyTypeGroupSelect',
      pageFrom: pageType,
    },
  }));

  const arrToUse = licenseTypeGroups && licenseTypeGroups.length && propertyTypes.length === 1 && propertyTypes[0] === 'Attività/Licenza (con o senza mura)'
    ? licenseTypeGroups
    : propertyTypes;

  const onKeyPress = (e) => {
    if (e.key === 'Enter') {
      choose();
    }
  };    
  
  return (
    <SearchBlock
      label="Cerco"
      button={arrToUse[0]}
      onClickAction={choose}
      onKeyPressAction={onKeyPress}
      className="sentenceElement"
      icon={<Icon aria-hidden="true" name={HpArrow} width="12px" height="7px" className="is-anim mb--xs" fill />}
      ariaLabel={`Cerco ${arrToUse[0]}${arrToUse.length > 1 ? ` e ${arrToUse.length - 1} altri` : ''}. Clicca per cambiare tipologia immobile`}        
      ariaHaspopup="dialog"
      more={arrToUse.length > 1 ? `+${arrToUse.length - 1}` : ''}
    />    
  );
};

export default PTypes;

PTypes.propTypes = {
  propertyTypes: PropTypes.instanceOf(Array),
  licenseTypeGroups: PropTypes.instanceOf(Array),
  availableResults: PropTypes.string,
};

PTypes.defaultProps = {
  propertyTypes: [],
  licenseTypeGroups: [],
  availableResults: '0',
};
